// Externe Bibliotheken
import React, { Component } from 'react';

// Styles
import './style.scss';

class LoadingCircle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            percentage: 10,
            t: 200,
            switchtime: 20000,
            text: '',
            isfinished: false,
        };
    }

    render() {
        return (
            <>
                <div id="loading-bar-spinner" className="spinner">
                    <div className="spinner-icon"></div>
                </div>
            </>
        );
    }
}

export default LoadingCircle;
